import React from "react";

// A status badge with a pulsing dot. status: "beta" | "pre-alpha" | "coming-soon"
export const StatusBadge = ({ label, tone = "gold", testid }) => {
  const toneClass =
    tone === "green"
      ? "border-emerald-500/40 text-emerald-300"
      : tone === "muted"
      ? "border-white/15 text-neutral-400"
      : "border-[#C9A87C]/40 text-[#C9A87C]";

  const dotClass =
    tone === "green"
      ? "bg-emerald-400"
      : tone === "muted"
      ? "bg-neutral-400"
      : "bg-[#C9A87C]";

  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-[10px] uppercase tracking-[0.28em] ${toneClass}`}
    >
      <span className={`pulse-dot inline-block h-1.5 w-1.5 rounded-full ${dotClass}`} />
      {label}
    </span>
  );
};

export default StatusBadge;
